import Vue from 'vue'
import Vuex from 'vuex'
import notifycation from './modules/notifycation';
import HomePage from './modules/homePage'

Vue.use(Vuex)

let firm = {
    state: {
        firm: {}
    },
    mutations: {
        setFirmInfo: (state, firm) => {
            Vue.set(state, "firm", firm)
        }
    },
    actions: {},
    getters: {},
}
let project = {
    state: {
        diagramStatus: {},
        currentProject: {
            projectId: 1,
        },
        weather:0, //0 晴天  1 阴天  2 雨天
        Radio: {
            proId: 0
        },
        uid:""
    },
    mutations: {
        setProjectInfo: (state, data) => {
            console.log(data);
            Vue.set(state, "projectInfo", data)
        },
        exportDiagram: (state, data) => {
            Vue.set(state, "diagramStatus", data)
        },
        setProjectId: (state, data) => {
            console.log(data);
            state.currentProject.projectId = data
        },
        ForegroundRadio: (state, data) => {
            state.Radio.proId = data
        },
        Setweather: (state, data) => {
            state.weather = data
        },
        uiditem(state, data){
            state.uid = data
        },

    },
    actions: {},
    getters: {
        projectId: (state) => {
            return state.currentProject.projectId
        }
    },
}

let token = {
    state: {
        token: "",
        isLogin: false,
    },
    mutations: {
        setToken: (state, token) => {
            state.isLogin = true
            state.token = token
           
        }
    },
    actions: {},
    getters: {},

}

let mqtt = {
    state: {
        all: {},
        alarm: {},
        max: {},
        mean: {},
        min: {}
    },
    mutations: {
        addMqttVal: (state, data) => {
            Vue.set(state.all, data.key, data.val)
        },
        addAlarm: (state, data) => {
            Vue.set(state.alarm, data.key, data.val)
        }

    },
    actions: {
        asyncAddMqttVal: ({
            state
        }, data) => {
            Vue.set(state.all, data.key, data.val)
        },
        addMqttValList: ({
            state
        }, list) => {
            list.forEach(data => {
                let key = data.key;
                let value = data.val;
                Vue.set(state.all, key, value)
                let current = state.max[key];
                if (current && current.val !== 0) {
                    if (current < value) {
                        Vue.set(state.max, key, {
                            val: value,
                            time: new Date()
                        })
                    }
                } else {
                    Vue.set(state.max, key, {
                        val: value,
                        time: new Date()
                    })
                }


                let currentMean = state.mean[key];
                if (currentMean) {
                    currentMean.val = (currentMean.val * currentMean.n + value) / (currentMean.n + 1)
                    currentMean.n = currentMean.n + 1
                } else {
                    Vue.set(state.mean, key, {
                        val: value,
                        n: 1
                    })
                }

                let currentMin = state.min[key]
                if (currentMin && currentMin.val !== 0) {
                    if (currentMin.val > value) {
                        Vue.set(state.min, key, {
                            val: value,
                            time: new Date()
                        })
                    }
                } else {
                    Vue.set(state.min, key, {
                        val: value,
                        time: new Date()
                    })
                }

            })
        }
    },
    getters: {
        mqttMinVal: state => key => state.min[key],
        mqttMeanVal: state => key => state.mean[key],
        mqttMaxVal: state => key => state.max[key],
        mqttVal: state => key => state.all[key],
        isAlarm: state => (loop, node) => {
            let alarmElement = state.alarm[`/${loop.subLoopUrl}/alarm/${node}`];
            if (alarmElement === undefined) {
                return false
            } else {
                return !alarmElement
            }
        }
    },
}
let homeitem = {
    state: {
 
       pro:'',
        //弧光保护
        protectStatus: "",
        //3D切换
        Dclick: 1,
        user: [],
        //首页切换
        testData: 0, //我是切换
        all: "",
        man: "",
        mqqtitem: "",
        mqqt: "",
        apk: '',
        png: "",
        massage: [],
        areaId: '',
        temp: {},
        monitoring: {},
        TitleAll: "",
        onestate1: "",
        onestate2: "",
        IformId: 0,
        getFom: 0,
        from:'',
        uid:""
    },
    mutations: {
        fomeitem(state, data){
            state.from = data
        },
        projectid(state, data){
            state.pro = data
        },
        GetEchart: (state, data) => {
            state.getFom = data
        },
        NavformDataId: (state, data) => {
            state.IformId = data
        },
        setData(state, data) {
            state.testData = data
        },
        allip(state, data) {
            state.all = data
        },
        mantotal(state, data) {
            state.man = data
        },
        forJq(state, data) {
            state.mqqtitem = data
        },
        fomeall(state, data) {
            state.mqqt = data
        },
        apkAll(state, data) {
            state.apk = data
        },
        getpng(state, data) {
            state.png = data
        },
        setUser(state, data) {
            state.user = data
        },
        massageBug(state, data) {
            state.massage = data
        },
        setlatest(state, data) {
            state.latest = data
        },
        webId(state, data) {
            state.areaId = data
        },
        tempmounted(state, data) {
            state.temp = data
        },
        monitoringName(state, data) {
            state.monitoring = data
        },
        addTitleAll(state, data) {
            state.TitleAll = data
        },
        Dthere(state, data) {
            state.Dclick = data
        },
        voltageClasses1(state, data) {
            state.onestate1 = data
        },
        voltageClasses2(state, data) {
            state.onestate2 = data
        },
        ArcprotectStatus(state, data) {
            state.protectStatus = data
        }

    },
    actions: {

    },
    getters: {

    },

}

export default new Vuex.Store({
    state: {},
    mutations: {
        clear: state => {
            state = {}
        }
    },
    actions: {},

    modules: {
        firm,
        project,
        token,
        mqtt,
        homeitem,
        notifycation,
        HomePage
    }
})